import gql from 'graphql-tag';

const GET_TAGS = gql`
  query Query($limit: Int!, $searchTerm: String!) {
    tagList(limit: $limit, searchTerm: $searchTerm) {
      tag {
        tag
      }
    }
  }
`;

export default GET_TAGS;
